<template>
  <div v-if="env !== 'prod'">
    <HeaderModule
      v-if="!$route.params.id"
      title="Services Directory Manager"
      icon="database-edit-outline"
      description="All things Services Directoy (OCSI Admins Only!)"
      padding="10px"
      :tabs="tabs"
      width="100%"
    >
      <template #servicesMetadataGroups>
        <ServicesMetadataGroups ref="servicesMetadataGroups" />
      </template>

      <template #servicesMetadata>
        <ServicesMetadata ref="servicesMetadata" />
      </template>

      <template #services>
        <Services ref="services" />
      </template>
    </HeaderModule>
    <router-view v-else></router-view>
  </div>
</template>
<script>
import HeaderModule from "@/components/HeaderModule.vue";
import { systemMessages } from "@/mixins/SystemMessages";
import ServicesMetadataGroups from "@/components/ServicesMetadataGroups.vue";
import ServicesMetadata from "@/components/ServicesMetadata.vue";
import Services from "@/components/SDServices.vue";

export default {
  name: "SDManager",
  mixins: [systemMessages],
  components: {
    HeaderModule,
    ServicesMetadataGroups,
    ServicesMetadata,
    Services,
  },
  props: {
    selectedTabRoute: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    env: process.env.VUE_APP_ENVIRONMENT,
    tabs: [
      {
        title: "Services Metadata Groups",
        value: "servicesMetadataGroups",
        route: "sd-services-metadata-groups",
      },
      {
        title: "Services Metadata",
        value: "servicesMetadata",
        route: "sd-services-metadata",
      },
      { title: "Services", value: "services", route: "sd-services" },
    ],
  }),
  created() {
    // this.stuff();
  },
  methods: {},
};
</script>

<style scoped></style>
